const Styles = {
    'PopoverContent': 'PopoverContent_PopoverContent--9d57b526'
};

export default Styles;